/** @file formatNumber: the text a numeric field shows for a value (no exponent, no float noise). */

/** `n` rounded to 6 decimals and written plainly (`0.3` not `0.30000000000000004`, `0` not `-0`). */
export function formatNumber(n: number): string {
  return String(Number(n.toFixed(6)));
}
